import { z } from "zod";

export const DashboardItemSchema = z.object({
  prospect: z.string(),
  case_number: z.string().nullable(),
  program: z.string(),
  no_of_transcripts: z.number(),
  opportunity_start_date: z.string().nullable(),
  advisor_name: z.string().nullable(),
  arize_url: z
    .array(
      z.object({
        url: z.string().nullable(),
        transcript_name: z.string().nullable(),
      }),
    )
    .nullable(),
  date_assigned: z.string().nullable(),
  status: z.string(),
  salesforce_last_modified_date: z.string().nullable(),
  trace_status: z.string(),
  trace_last_modified_date: z.string().nullable().optional(),
  closed_date: z.string().nullable().optional(),
  brand_profile_id: z.string(),
});

export const DashboardResponseSchema = z.object({
  data: z.array(DashboardItemSchema),
  total_count: z.number(),
  status_analytics: z.record(z.string(), z.number()),
  advisor_id: z.string().nullable(),
  last_sync_date: z.string().nullable().optional(),
  limit: z.number(),
  page: z.number(),
});

export const ProspectTranscriptSchema = z.object({
  converted_url: z.string().url().nullable().optional(),
  transcript_file_name: z.string(),
  transcript_blob_url: z.string().url(),
  transcript_blob_path: z.string(),
});

export const ProspectDetailsSchema = z.array(
  z.object({
    student_name: z.string(),
    student_id: z.string().nullable(),
    case_number: z.string().min(1),
    program: z.string().min(1),
    start_date: z.string().nullable(),
    metadata_exists: z.boolean().optional(),
    transcript: z
      .array(ProspectTranscriptSchema)
      .min(1, "At least one transcript is required"),
  }),
);

export const FiltersResponseSchema = z.object({
  no_of_transcripts: z.array(z.int()),
  programs: z.array(z.string()),
  status: z.array(z.string()).nullable().optional(),
  tlo_status: z.array(z.string()).nullable().optional(),
});

export type DashboardItem = z.infer<typeof DashboardItemSchema>;
export type DashboardResponse = z.infer<typeof DashboardResponseSchema>;
export type ProspectDetails = z.infer<typeof ProspectDetailsSchema>;
export type FiltersResponse = z.infer<typeof FiltersResponseSchema>;
